import React, { useState, useEffect } from "react";
import {Container, Row, Col} from "react-bootstrap";
import Menu from "./components/Menu";
import NinjaSelection from "./components/NinjaSelection";
import NinjaRelics from "./components/NinjaRelics";
import Backpack from "./components/Backpack";
import RelicSelection from "./components/RelicSelection";
import { relics } from "./data/relics";
import { stats } from "./data/relics";
import { sets } from "./data/relics";
import { ninjas } from "./data/relics";
import { decompressFromEncodedURIComponent } from "lz-string";
import StatComparison from "./components/StatComparison";

const App = () => {

    useEffect(() => {
        loadStatsFromQueryParams();
    }, []);

    const [ninja1, setNinja1] = useState(ninjas[0]);
    const [ninja1Relics, setNinja1Relics] = useState([null, null, null, null, null]);
    const [ninja1Stats, setNinja1Stats] = useState({});
    const [ninja1Shuriken, setNinja1Shuriken] = useState(0);
    const [ninja1Weapon, setNinja1Weapon] = useState(0);
    const [ninja1Ninjutsu, setNinja1Ninjutsu] = useState(0);

    useEffect(() => {
        let stats = calculateStats(ninja1Relics, ninja1)
        setNinja1Stats(stats);
    }, [ninja1Relics, ninja1]);

    useEffect(() => {
        let shurikenElement = isShurikenEquipped(ninja1Relics, ninja1) ? getStat(ninja1Stats, ninja1.element) : 0;
        setNinja1Shuriken(getStat(ninja1Stats, 'atk') + getStat(ninja1Stats, 'shuriken') + shurikenElement);
        setNinja1Weapon(getStat(ninja1Stats, 'atk') + getStat(ninja1Stats, 'weapon') + getStat(ninja1Stats, ninja1.element));
        setNinja1Ninjutsu(getStat(ninja1Stats, 'atk') + getStat(ninja1Stats, 'ninjutsu') + getStat(ninja1Stats, ninja1.element));
    }, [ninja1Stats]);


    const [ninja2, setNinja2] = useState(ninjas[0]);
    const [ninja2Relics, setNinja2Relics] = useState([null, null, null, null, null]);
    const [ninja2Stats, setNinja2Stats] = useState({});
    const [ninja2Shuriken, setNinja2Shuriken] = useState(0);
    const [ninja2Weapon, setNinja2Weapon] = useState(0);
    const [ninja2Ninjutsu, setNinja2Ninjutsu] = useState(0);

    useEffect(() => {
        let stats = calculateStats(ninja2Relics, ninja2)
        setNinja2Stats(stats);
    }, [ninja2Relics, ninja2]);

    useEffect(() => {
        let shurikenElement = isShurikenEquipped(ninja2Relics, ninja2) ? getStat(ninja2Stats, ninja2.element) : 0;
        setNinja2Shuriken(getStat(ninja2Stats, 'atk') + getStat(ninja2Stats, 'shuriken') + shurikenElement);
        setNinja2Weapon(getStat(ninja2Stats, 'atk') + getStat(ninja2Stats, 'weapon') + getStat(ninja2Stats, ninja2.element));
        setNinja2Ninjutsu(getStat(ninja2Stats, 'atk') + getStat(ninja2Stats, 'ninjutsu') + getStat(ninja2Stats, ninja2.element));
    }, [ninja2Stats]);

    const [showSelection, setShowSelection] = useState(false);
    const [readyToEquip, setReadyToEquip] = useState(false);
    const [selectedRelic, setSelectedRelic] = useState(null);
    const [selectedLevel, setSelectedLevel] = useState('');
    const [selectionButtonText, setSelectionButtonText] = useState('Equip');
    const [indexToRemove, setIndexToRemove] = useState(null);
    const [currentSide, setCurrentSide] = useState('1');

    const loadStatsFromQueryParams = () => {
        let search = window.location.search;
        let urlSearchParams = new URLSearchParams(search);
        let encodedBuild = urlSearchParams.get('build');
        if (null === encodedBuild)
        {
            return;
        }

        let buildString = decompressFromEncodedURIComponent(encodedBuild);
        let build = JSON.parse(buildString);
        setNinja1(build.ninja1);
        setNinja1Relics(build.ninja1Relics);
        setNinja2(build.ninja2);
        setNinja2Relics(build.ninja2Relics);

        window.history.replaceState({}, document.title, window.location.pathname);
    };

    const handleRemove = () => {
        if ('1' === currentSide)
        {
            ninja1Relics[indexToRemove] = null;
            setNinja1Relics([...ninja1Relics]);
        }
        else
        {
            ninja2Relics[indexToRemove] = null;
            setNinja2Relics([...ninja2Relics]);
        }
        setShowSelection(false);
    };

    const calculateStats = (relics, ninja) => {
        let i, len, j, len2;
        let stats = {};
        let setBonuses = {};

        for (i = 0, len = relics.length; i < len; i++)
        {
            let equippedRelic = relics[i];
            if (equippedRelic === null)
            {
                continue;
            }

            let selectedStats = equippedRelic.stats[equippedRelic.level];
            let statKeys = Object.keys(selectedStats);
            
            for (j = 0, len2 = statKeys.length; j < len2; j++)
            {
                let key = statKeys[j];
                let value = selectedStats[key];

                if ('ninjutsuNinja' === key)
                {
                    if (ninja.element === equippedRelic.element)
                    {
                        key = 'ninjutsu';
                    }
                    else
                    {
                        continue;
                    }
                }

                if ('shurikenNinja' === key)
                {
                    if (ninja.element === equippedRelic.element)
                    {
                        key = 'shuriken';
                    }
                    else
                    {
                        continue;
                    }
                }

                if (stats.hasOwnProperty(key))
                {
                    stats[key] += value;
                }
                else
                {
                    stats[key] = value;
                }
            }

            if (!equippedRelic.hasOwnProperty('set'))
            {
                continue;
            }
            
            let setName = equippedRelic.set;
            let set = sets[setName];
            let selectedBonus = set.stats[equippedRelic.level];
            let bonusKeys = Object.keys(selectedBonus);

            for (j = 0, len2 = bonusKeys.length; j < len2; j++)
            {
                let key = bonusKeys[j];
                let value = selectedBonus[key];

                if ('ninjutsuNinja' === key)
                {
                    if (ninja.element === equippedRelic.element)
                    {
                        key = 'ninjutsu';
                    }
                    else
                    {
                        continue;
                    }
                }

                if ('shurikenNinja' === key)
                {
                    if (ninja.element === equippedRelic.element)
                    {
                        key = 'shuriken';
                    }
                    else
                    {
                        continue;
                    }
                }

                if (setBonuses.hasOwnProperty(key))
                {
                    setBonuses[key].push(value);
                }
                else
                {
                    setBonuses[key] = [value];
                }
            }
        }

        let setBonusKeys = Object.keys(setBonuses);

        for (i = 0, len = setBonusKeys.length; i < len; i++)
        {
            let key = setBonusKeys[i];
            let values =  setBonuses[key];
            if (values.length > 1)
            {
                let value = Math.min(...values)
                if (stats.hasOwnProperty(key))
                {
                    stats[key] += value;
                }
                else
                {
                    stats[key] = value;
                }
            }
        }

        return stats;
    };

    const getStat = (stats, key) => {
        return stats[key] ? stats[key] : 0;
    };

    const isShurikenEquipped = (relics, ninja) => {
        let i, len;
        for (i = 0, len = relics.length; i < len; i++)
        {
            let equippedRelic = relics[i];
            if (equippedRelic?.value.includes('Shuriken') && equippedRelic.element === ninja?.element)
            {
                return true;
            }
        }
        return false;
    };

    return (
        <Container fluid className="app p-2">
            <Row className="d-flex justify-content-center ps-1" onClick={() => {setShowSelection(false)}}>
                <Col xs={'auto'} className="p-0">
                    <NinjaSelection
                        side={'1'}
                        ninja={ninja1}
                        setSelectedNinja={setNinja1}
                        setRelics={setNinja1Relics}
                    />
                </Col>
                <Col xs={'auto'} className="p-0" style={{width: '190px'}}>
                    <Menu
                        ninja1={ninja1}
                        setNinja1={setNinja1}
                        ninja1Relics={ninja1Relics}
                        setNinja1Relics={setNinja1Relics}
                        ninja2={ninja2}
                        setNinja2={setNinja2}
                        ninja2Relics={ninja2Relics}
                        setNinja2Relics={setNinja2Relics}
                    />
                </Col>
                <Col xs={'auto'} className="p-0">
                    <NinjaSelection
                        side={'2'}
                        ninja={ninja2}
                        setSelectedNinja={setNinja2}
                        setRelics={setNinja2Relics}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-center ps-1">
                <Col xs={'auto'} className="p-0">
                    <NinjaRelics
                        side={'1'}
                        setCurrentSide={setCurrentSide}
                        ninja={ninja1}
                        relics={ninja1Relics}
                        setRelics={setNinja1Relics}
                        readyToEquip={readyToEquip}
                        setReadyToEquip={setReadyToEquip}
                        selectedLevel={selectedLevel}
                        selectedRelic={selectedRelic}
                        setSelectedRelic={setSelectedRelic}
                        showSelection={showSelection}
                        setShowSelection={setShowSelection}
                        setSelectionButtonText={setSelectionButtonText}
                        setIndexToRemove={setIndexToRemove}
                    />
                </Col>
                <Col xs={'auto'} className="p-0">
                    <Backpack
                        selectedLevel={selectedLevel}
                        setSelectedLevel={setSelectedLevel}
                        setSelectedRelic={setSelectedRelic}
                        setSelectionButtonText={setSelectionButtonText}
                        showSelection={showSelection}
                        setShowSelection={setShowSelection}
                    />
                </Col>
                <Col xs={'auto'} className="p-0">
                    <NinjaRelics
                        side={'2'}
                        setCurrentSide={setCurrentSide}
                        ninja={ninja2}
                        relics={ninja2Relics}
                        setRelics={setNinja2Relics}
                        readyToEquip={readyToEquip}
                        setReadyToEquip={setReadyToEquip}
                        selectedLevel={selectedLevel}
                        selectedRelic={selectedRelic}
                        setSelectedRelic={setSelectedRelic}
                        showSelection={showSelection}
                        setShowSelection={setShowSelection}
                        setSelectionButtonText={setSelectionButtonText}
                        setIndexToRemove={setIndexToRemove}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-center ps-1">
                { showSelection
                    ?
                    <Col xs={'auto'} className="p-0">
                        <RelicSelection
                            selectedRelic={selectedRelic}
                            selectedLevel={selectedLevel}
                            setSelectedLevel={setSelectedLevel}
                            setReadyToEquip={setReadyToEquip}
                            selectionButtonText={selectionButtonText}
                            handleRemove={handleRemove}
                            setShowSelection={setShowSelection}
                        /> 
                    </Col>
                    :
                    <StatComparison
                        ninja1Stats={ninja1Stats}
                        ninja1Shuriken={ninja1Shuriken}
                        ninja1Weapon={ninja1Weapon}
                        ninja1Ninjutsu={ninja1Ninjutsu}
                        ninja2Stats={ninja2Stats}
                        ninja2Shuriken={ninja2Shuriken}
                        ninja2Weapon={ninja2Weapon}
                        ninja2Ninjutsu={ninja2Ninjutsu}
                    />
                }
            </Row>
        </Container>
    );
};

export default App;
